/* eslint-disable @typescript-eslint/no-explicit-any */
import { supabase } from '../lib/supabaseClient';

export interface OrderCommentRecord {
  id: string;
  orderId: string;
  userId: string | null;
  comment: string | null;
  foodRating: number | null;
  deliveryRating: number | null;
  overallRating: number | null;
  createdAt: string;
  orderTotal: number | null;
  orderStatus: string | null;
  orderPlacedAt: string | null;
  restaurantName: string | null;
  customerName: string | null;
  customerEmail: string | null;
  customerPhone: string | null;
}

const REVIEW_SELECT = `
  *,
  orders:orders (
    id,
    status,
    total_amount,
    created_at,
    restaurants:restaurants (
      id,
      name
    )
  ),
  users:users (
    id,
    full_name,
    email,
    phone
  )
`;

export async function listOrderComments(): Promise<OrderCommentRecord[]> {
  const { data, error } = await supabase
    .from('order_reviews')
    .select(REVIEW_SELECT)
    .order('created_at', { ascending: false })
    .limit(250);

  if (error) {
    throw error;
  }

  return (data ?? []).map((row: any) => ({
    id: row.id,
    orderId: row.order_id,
    userId: row.user_id ?? null,
    comment: row.comment ?? row.feedback ?? null,
    foodRating: row.food_rating ?? null,
    deliveryRating: row.delivery_rating ?? null,
    overallRating: row.overall_rating ?? null,
    createdAt: row.created_at,
    orderTotal: row.orders?.total_amount ?? null,
    orderStatus: row.orders?.status ?? null,
    orderPlacedAt: row.orders?.created_at ?? null,
    restaurantName: row.orders?.restaurants?.name ?? null,
    customerName: row.users?.full_name ?? null,
    customerEmail: row.users?.email ?? null,
    customerPhone: row.users?.phone ?? null,
  }));
}
